import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "v-application--is-ltr" }
const _hoisted_2 = { class: "modal__camera-template-wrapper" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 1,
  class: "camera-loading"
}
const _hoisted_5 = {
  key: 2,
  class: "modal__camera-content"
}
const _hoisted_6 = {
  key: 0,
  class: "modal__camera-slider"
}
const _hoisted_7 = { class: "modal__camera-image-box" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  class: "modal__camera-datetime"
}
const _hoisted_10 = {
  key: 1,
  class: "modal__camera-image-off"
}
const _hoisted_11 = { class: "modal__camera-image-off-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_carousel_item = _resolveComponent("v-carousel-item")!
  const _component_v_carousel = _resolveComponent("v-carousel")!
  const _component_translated_text_component = _resolveComponent("translated-text-component")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.descriptionTop)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "modal__description modal__camera-desc",
            innerHTML: _ctx.descriptionTop
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "secondary",
              size: "50"
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_ctx.cameraImages && _ctx.cameraImages.length && _ctx.modalData.preview)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_v_carousel, {
                    continuous: false,
                    "hide-delimiters": "",
                    theme: "dark",
                    height: "auto",
                    color: "secondary",
                    class: "modal__camera-image-list"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cameraImages, (item) => {
                        return (_openBlock(), _createBlock(_component_v_carousel_item, {
                          eager: "",
                          key: item.index,
                          class: "modal__camera-image-item"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_7, [
                              (item.code)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: `data:${item.mime_type};base64,${item.code}`
                                  }, null, 8, _hoisted_8))
                                : _createCommentVNode("", true)
                            ]),
                            (item.code && item.date_time)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.formatDate(item.date_time)), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _cache[0] || (_cache[0] = _createElementVNode("i", { class: "mdi mdi-eye-off" }, null, -1)),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_translated_text_component, { translation: "modal_camera_no_image_text" })
                  ])
                ]))
          ]))
    ])
  ]))
}